import { TotalizerRoot } from "./TotalizerRoot";
import { TotalizerContent } from "./TotalizerContent";

export const Totalizer = {
  Root: TotalizerRoot,
  Content: TotalizerContent,
};
